import { createContext, useContext } from "react";

export const NavContext = createContext({ navData: {}, servicesData: [] });

export const useNavData = () => useContext(NavContext);
